import React, {useEffect, useState } from 'react'
import "./CartsDetails.css"
import './CheckoutProduct.css'
import dataCarts from './dataCarts'
import { useStateValue } from './StateProvider';
import axios from 'axios';
import CurrencyFormat from 'react-currency-format';
import { useHistory } from 'react-router-dom';

function CartsDetails() {
  const [{ basket, productDetalis }, dispatch] = useStateValue();
  const [product, setProduct] = useState([]);
  const [id, setId] = useState('')
  const [title, setTitle] = useState('');
  const [price, setPrice] = useState('');
  const [img, setImg] = useState('');
  const [weigth, setWeigth] = useState('');
  const [dimensions, setDimensions] = useState('');
  const [sold, setSold] = useState();
  var matchcount = 0;
  const history = useHistory();

  useEffect(() => {
    
    if(productDetalis.length === 0){
        history.push('/');
    }    
}, [])

  useEffect(() => {
    productDetalis.map(item =>{
      setId(item.id)
      setTitle(item.title)
      setPrice(item.price)
      setImg(item.img);
      setSold(item.sold)

      axios
          .get('https://toycityzimbabwe.com/backend/getSpecs.php', {params: {name: item.title}})
          .then(res => {
            setProduct(res.data)
            console.log(res.data)
          })
          .catch( error => {
              console.log(error)
          });
    })
    
      
  }, []);

  useEffect(() => {
    product.map(item => {
      setWeigth(item.pdescription);
      setDimensions(item.dimension);
    })
    
  }, [product])

  const [slideIndex, setSlideIndex] = useState(1);

  useEffect(() => {
    const lastIndex = dataCarts.length
    
    if(slideIndex < 1){
        setSlideIndex(lastIndex)
    }

    if( slideIndex > lastIndex){
        setSlideIndex(1)
    }
  }, [slideIndex])

  useEffect(() => {
    let slider = setInterval(() => {
        setSlideIndex(slideIndex + 1)
    }, 5000);
    return () => clearInterval(slider)
  }, [slideIndex])

  const moveDot = index => {
    setSlideIndex(index)
  }

  const addToBasket =() =>{
    // dispatch the item into the data layer
    dispatch({
        type: "ADD_TO_BASKET",
        item:{
            id: id,
            title: title,
            price: price,
            img: img,
            qnt: 1
        },
    });
  }

  const qntBasket =() =>{
    
    basket.map(item =>{

        if(item.id === id){
            item.qnt = item.qnt + 1;
            dispatch({
                type: "ADD_TO_Qnt",
                id: id,
                title: title,
                price: price,
                img: img,
                qnt: item.qnt
            });
        }
        else{
            matchcount += 1
        }

    })

    if(basket.length === matchcount){
        matchcount = 0;
        addToBasket()
    }  
};

  return (
    <div className="container-carts">
      <div className='details-cont'>
        {product.map((obj, index) => {
          
              return (
                  <div
                  key={obj.id}
                  className={slideIndex === index + 1 ? "slide active-anim" : "slide"}
                  >
                      <img 
                        src={obj.product_img} 
                      />
                  </div>
                )
          })}
          <div className="container-cartdots">
            {product.map((item, index) => (
                <div 
                  onClick={() => moveDot(index + 1)}
                  className={slideIndex === index + 1 ? "cartdot activee" : "cartdot"}
                  
                >
                  <img 
                        src={item.product_img} 
                  />
                </div>
            ))}
          </div>
      </div>
      
      <div className='carts-details'>
          <p>{title}</p>
          <h2><div className='price-display'>
                <CurrencyFormat
                    renderText={(value) => (
                        <>
                            <h3>{value}</h3>
                        </>
                    )}
                    decimalScale={2}
                    value={price}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                />
            </div></h2>
            {(sold == 0) ? <button onClick={basket.length === 0 ? addToBasket : qntBasket}>Add to cart</button>
          :<div className="product__btn __sold"><button>Sold Out</button></div>}
      </div>
      <h3>Specifications</h3>
      <div className='specs-cont'>
        <table>
          <tr>
            <th>Description:</th>
            <td>{weigth}</td>
          </tr> 
          <tr> 
            <th>Dimensions:</th>
            <td>{dimensions}</td>
          </tr>
        </table>  
      </div>
    </div>
  )
}

export default CartsDetails;